import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../../components/default/DefaultCard';
import LazyLoading from '../../../components/LazyLoading';
import useSocietyClientService from '../../../app/services/hooks/useSocietyClientService';
import SocietyContactContainer from '../../Societies/components/SocietyContactContainer';
import { ServiceResponse } from '../../../app/services/shared/interfaces';

type RouterParams = { id: string };

interface BNDetail {
  id: number;
  name: string | null;
  rut: string | null;
  email: string | null;
  phone_code: string | null;
  phone: string | null;
  address: string | null;
  country: string | null;
  fantasy_name: string | null;
  website: string | null;
}

interface ClientDetail {
  id: number;
  business_name_id: number | null;
  business_name: string | null;
  business_name_detail: BNDetail | null;
}

const ClientEditPage: React.FC = () => {
  const { id } = useParams<RouterParams>();
  const societyClientId = Number(id);

  const [clientDetail, setClientDetail] = useState<ClientDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const { editSocietyClient } = useSocietyClientService();
  const calledRef = useRef(false);

  useEffect(() => {
    if (!Number.isFinite(societyClientId) || societyClientId <= 0) return;
    if (calledRef.current) return;
    calledRef.current = true;

    setLoading(true);
    editSocietyClient(societyClientId, {
      onSuccess: (resp: ServiceResponse) => {
        const detail = resp.data?.client_detail as ClientDetail | null;
        setClientDetail(detail ?? null);
        setLoading(false);
        setDone(true);
      },
      onError: () => {
        setClientDetail(null);
        setLoading(false);
        setDone(true);
      },
    });
  }, [societyClientId]); // eslint-disable-line

  const bn = clientDetail?.business_name_detail ?? null;

  const breadcrumbs: BreadcrumbsItem[] = [
    { name: 'Clientes', url: '/clients', isActive: false },
    { name: `Editar cliente #${societyClientId}`, url: `/clients/${societyClientId}/edit`, isActive: true },
  ];

  return (
    <>
      <Breadcrumbs pageSection={`Editar cliente #${societyClientId}`} breadcrumbs={breadcrumbs} />

      <DefaultCard>
        <div className="h3 mt-0 mb-2 card-title">Datos del cliente</div>
        <p className="text-muted small mb-3">Información de la razón social asociada al cliente.</p>

        {loading ? (
          <LazyLoading height={300} />
        ) : bn ? (
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">Razón Social</label>
              <input className="form-control form-control-sm bg-light" value={bn.name || ''} readOnly />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">RUT</label>
              <input className="form-control form-control-sm bg-light" value={bn.rut || ''} readOnly />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">Nombre de fantasía</label>
              <input className="form-control form-control-sm bg-light" value={bn.fantasy_name || ''} readOnly />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">País</label>
              <input className="form-control form-control-sm bg-light" value={bn.country || ''} readOnly />
            </div>
            <div className="col-12">
              <label className="form-label fw-semibold text-secondary small text-uppercase">Dirección</label>
              <input className="form-control form-control-sm bg-light" value={bn.address || ''} readOnly />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">Teléfono</label>
              <input
                className="form-control form-control-sm bg-light"
                value={[bn.phone_code, bn.phone].filter(Boolean).join(' ') || ''}
                readOnly
              />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold text-secondary small text-uppercase">Correo</label>
              <input className="form-control form-control-sm bg-light" value={bn.email || ''} readOnly />
            </div>
          </div>
        ) : done ? (
          <div className="text-muted">No se encontraron datos del cliente.</div>
        ) : null}
      </DefaultCard>

      {clientDetail?.business_name_id != null && clientDetail.business_name_id > 0 && (
        <SocietyContactContainer
          societyId={0}
          businessNameId={clientDetail.business_name_id}
          isShow={false}
        />
      )}
    </>
  );
};

export default ClientEditPage;
